<template>
	<div class="view flex-parent">
		<div
			class="flex-center main container border-l player-name-div"
			id="player-name-div"
		>
			<div class="join-game-form">
				<h1 class="mb-24">Join game {{ gameId }}</h1>
				<form id="player-name-form">
					<label
						for="playerName"
						id="player-name-label"
						class="player-name-label"
						:class="[playerNameLabel.class]"
						>{{ playerNameLabel.text }}</label
					>
					<div class="form-div">
						<player-name-input
							v-model="playerName"
							placeholder="My name Borat"
						></player-name-input>
						<div class="button-div">
							<primary-button
								class="btn m"
								@click.prevent="handleJoin"
								>Join game</primary-button
							>
						</div>
					</div>
				</form>
			</div>
			<h4 class="align-c mt-40 tc-secondary">
				<router-link :to="'/login'" class="tc-secondary router">
					Back to home
				</router-link>
			</h4>
		</div>
	</div>
</template>

<script>
import PrimaryButton from "@/components/ui/PrimaryButton";
import PlayerNameInput from "@/components/ui/PlayerNameInput";
import { mapActions, mapGetters } from "vuex";

export default {
	name: "Login",
	components: {
		PrimaryButton,
		PlayerNameInput,
	},
	props: ["gameId"],
	data() {
		return {
			playerName: "",
			playerNameLabel: {
				text: "Your name",
				class: {
					error: false,
					success: false,
				},
			},
		};
	},
	computed: {
		...mapGetters(["mockingServer", "isDev"]),
	},
	methods: {
		...mapActions(["tryJoinGame"]),
		logData() {
			// console.log("Player name:", this.playerName);
			// console.log("Room code:", this.roomCode);
		},
		handleJoin() {
			if (this.playerName) {
				this.tryJoinGame({
					aRoomCode: this.gameId,
					aName: this.playerName,
				});
			}
		},
		makeId(length) {
			var result = "";
			var characters =
				"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			var charactersLength = characters.length;
			for (var i = 0; i < length; i++) {
				result += characters.charAt(
					Math.floor(Math.random() * charactersLength)
				);
			}
			return result;
		},
	},
	created() {
		// console.log("\n::: INVITE.VUE");
		// console.log("GameId prop to Invite.vue", this.gameId);
		if (this.isDev) this.playerName = this.makeId(8);
		if (this.mockingServer) this.handleJoin();
	},
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";
@import "../assets/scss/input.scss";
@import "../assets/scss/lobby.scss";

.join-game-form {
	display: block;
}

.new-game {
	width: 100%;
}
</style>
